// extracted by mini-css-extract-plugin
export default {"backLink":"BackLink_backLink__JiXo7","iconBack":"BackLink_iconBack__+i-ak"};